export default "__VITE_ASSET__CABxdRh5__"